export default function createFormState(product, form, previousFormState = null) {
  const formData = new FormData(form);
  const { options, variants } = product;

  let fieldsetsData = options.map((optionName, optionIndex) => {
    const optionValues = [...new Set(variants.map((variant) => variant.options[optionIndex]))];
    const formOptionValue = formData.get(optionName);

    let closestMatchingValueIndex = -1;

    if (!optionValues.includes(formOptionValue) && previousFormState) {
      closestMatchingValueIndex = Math.min(
        optionValues.length - 1,
        previousFormState.fieldsets[optionIndex].options.findIndex(
          (option) => option.value === formOptionValue,
        ),
      );
    }

    const optionValueObjects = optionValues.map((value, index) => ({
      availability: 0, // Updated in next step
      checked:
        formOptionValue === value ||
        optionValues.length === 1 ||
        index === closestMatchingValueIndex,
      name: optionName,
      value,
    }));

    const fieldsetObject = {
      name: optionName,
      selectedOption: optionValueObjects.findIndex((option) => option.checked),
      options: optionValueObjects,
    };

    return fieldsetObject;
  }, {});

  // Update all option objects with availability
  const formOptionsWithValues = options.map((optionName, optionIndex) => [
    optionIndex,
    fieldsetsData[optionIndex].selectedOption,
  ]);

  const optionsWithSelection = formOptionsWithValues.filter(([, valueIndex]) => valueIndex > -1);

  fieldsetsData = fieldsetsData.map((fieldset, optionIndex) => {
    const applicableOptionsWithSelection = optionsWithSelection.filter(
      ([optIndex]) => optIndex !== optionIndex,
    );
    const applicableVariants = variants.filter((variant) =>
      applicableOptionsWithSelection.every(
        ([optIndex, optionValueIndex]) =>
          variant.options[optIndex] === fieldsetsData[optIndex].options[optionValueIndex].value,
      ),
    );

    return {
      ...fieldset,
      options: fieldset.options.map((option) => {
        let availability = 0;

        const variantsWithOption = applicableVariants.filter(
          (variant) => variant.options[optionIndex] === option.value,
        );

        // If there are variants (matching the form values) with the current option
        if (variantsWithOption.length > 0) {
          availability = variantsWithOption.some((variant) => variant.available) ? 2 : 1;
        }

        return {
          ...option,
          availability,
        };
      }),
    };
  });

  // Adjust checked options based on availabiliy
  /*
  fieldsetsData = fieldsetsData.map((fieldset) => {
    const selectedOptionIndex = fieldset.selectedOption;

    let closestOptionIndex = null;
    if (selectedOptionIndex > -1 && fieldset.options[selectedOptionIndex].availability === 0) {
      for (let i = selectedOptionIndex; i > 0; i -= 1) {
        if (fieldset.options[i].availability > 0) {
          closestOptionIndex = i;
          break;
        }
      }

      if (closestOptionIndex === null) {
        for (let i = selectedOptionIndex; i < fieldset.options.length; i += 1) {
          if (fieldset.options[i].availability > 0) {
            closestOptionIndex = i;
            break;
          }
        }
      }
    }

    return {
      ...fieldset,
      options: fieldset.options.map((option, index) => ({
        ...option,
        checked: closestOptionIndex !== null ? index === closestOptionIndex : option.checked,
      })),
      selectedOption: closestOptionIndex !== null ? closestOptionIndex : selectedOptionIndex,
    };
  });
  */

  let selectedVariant = null;

  // If all fieldsets have a selected option, get the correct variant
  if (fieldsetsData.every((fieldset) => fieldset.selectedOption > -1)) {
    const selectedValues = fieldsetsData.map(
      (fieldset) => fieldset.options[fieldset.selectedOption].value,
    );

    selectedVariant =
      variants.find((variant) =>
        selectedValues.every((value, index) => variant.options[index] === value),
      ) || false;
  }

  return {
    product,
    selectedVariant,
    fieldsets: fieldsetsData,
  };
}
